module.exports = __webpack_public_path__ + "img/weather_sagittarius.166882bc.svg";